<div class="kendo-checkbox-container" [ngClass]="cssClass" [class.has-error]="showErrorState">
  <!-- Select All Checkbox (for multiple selection mode) -->
  <div
    class="k-checkbox-wrapper select-all-wrapper"
    *ngIf="multiple && showSelectAllControls && options.length > 2"
  >
    <input
      type="checkbox"
      kendoCheckBox
      id="selectAll"
      [checked]="selectAllState"
      [indeterminate]="selectAllIndeterminate"
      [disabled]="disabled"
      (change)="onSelectAllChange()"
      aria-label="Select all items"
    />
    <label class="k-checkbox-label" for="selectAll">
      Select All
      <span class="checkbox-count">
        ({{ getCheckedCount() }} / {{ getTotalCount() }} selected)
      </span>
    </label>
  </div>

  <div class="k-separator" *ngIf="multiple && showSelectAllControls && options.length > 2"></div>

  <!-- Checkbox Options Container -->
  <div
    class="checkbox-options-container"
    [ngClass]="{
      'horizontal-layout': layout === 'horizontal',
      'vertical-layout': layout === 'vertical',
    }"
  >
    <div
      class="k-checkbox-wrapper"
      *ngFor="let option of options; trackBy: trackByOption"
      [ngClass]="{
        'disabled-option': option.disabled,
        'k-state-disabled': option.disabled,
      }"
    >
      <!-- Label Before -->
      <label
        *ngIf="labelPosition === 'before'"
        [for]="option.id"
        class="k-checkbox-label checkbox-label label-before"
      >
        {{ option.label }}
      </label>

      <!-- Kendo Checkbox -->
      <input
        type="checkbox"
        kendoCheckBox
        [id]="option.id"
        [value]="option.value"
        [checked]="option.checked"
        [disabled]="option.disabled || disabled"
        [indeterminate]="option.indeterminate"
        (change)="onCheckboxChange(option)"
        [attr.aria-label]="option.label"
        [attr.aria-checked]="option.checked"
        [attr.aria-disabled]="option.disabled || disabled"
      />

      <!-- Label After (default) -->
      <label *ngIf="labelPosition === 'after'" [for]="option.id" class="k-checkbox-label">
        {{ option.label }}
      </label>
    </div>
  </div>

  <!-- Helper Text Area -->
  <div class="helper-text" *ngIf="(hint && !showErrorState) || showErrorState">
    <span *ngIf="hint && !showErrorState" class="hint-text">{{ hint }}</span>
    <span *ngIf="showErrorState" class="error-text">* {{ currentErrorMessage }}</span>
  </div>
</div>
